import '../ReactComponents/extensions/StringExtensions';

import { isServerRendering } from '@farmasiet/frontendcore-reactcomponents';
import { useStaticRendering } from 'mobx-react';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import * as ReactDOMServer from 'react-dom/server';
import smoothscroll from 'smoothscroll-polyfill';

import { ActionHero } from '../Blocks/ActionHero/ActionHero';
import { AlertRibbon } from '../Blocks/AlertRibbon/AlertRibbon';
import ImageBanner from '../Blocks/Banners/ImageBanner/ImageBanner';
import SectionBanner from '../Blocks/Banners/SectionBanner/SectionBanner';
import SimpleImageBanner from '../Blocks/Banners/SimpleImageBanner/SimpleImageBanner';
import WideImageBanner from '../Blocks/Banners/WideImageBanner/WideImageBanner';
import { BrandList } from '../Blocks/BrandList/BrandList';
import { CallToAction } from '../Blocks/CallToAction/CallToAction';
import { CallToActionList } from '../Blocks/CallToActionList/CallToActionList';
import { CategoryBlock } from '../Blocks/CategoryBlock/CategoryBlock';
import { CookiesConsent } from '../Blocks/CookiesConsent/CookiesConsent';
import { LinkList } from '../Blocks/LinkList/LinkList';
import MainBanner from '../Blocks/MainBanner/MainBanner';
import { MainBannerGallery } from '../Blocks/MainBannerGallery/MainBannerGallery';
import { CircleInfo } from '../Blocks/Products/FeaturedProducts/FeaturedProductsCompatibleBlock/CircleInfo/CircleInfo';
import { FeaturedInfo } from '../Blocks/Products/FeaturedProducts/FeaturedProductsCompatibleBlock/FeaturedInfo/FeaturedInfo';
import { RxBanner } from '../Blocks/RxBanner/RxBanner';
import TextBanner from '../Blocks/TextBanner/TextBanner';
import { Video } from '../Blocks/Video/Video';
import { CategoryHeader } from '../Catalog/Category/CategoryHeader';
import { ProductImpression } from '../Catalog/Product/ProductImpression';
import { ProductPageDiscount } from '../Catalog/Product/ProductPageDiscount';
import CustomerHeader from '../Components/CustomerHeader/CustomerHeader';
import { FavouriteProductButton } from '../Customers/Favourites/Components/FavouritesButton/FavouriteProductButton';
import { FirstFavouriteModal } from '../Customers/Favourites/Components/FirstFavouriteModal/FirstFavouriteModal';
import { FavouriteProductsList } from '../Customers/Favourites/FavouritesList/Components/FavouriteProductsList';
import { ProductPageAvailabilityNotificationWrapper } from '../Customers/Notifications/ProductAvailability/Components/ProductAvailabilityNotification/ProductPageAvailabilityNotificationWrapper';
import { NewsletterSubscription } from '../Marketing/Newsletter/Block/NewsletterSubscriptionBlock';
import { UnsubscribeReason } from '../Marketing/Newsletter/Pages/UnsubscribePage/UnsubscribeReason/UnsubscribeReason';
import OrderDetails from '../Orders/Pages/OrderDetails/Components/OrderDetails';
import OrderHistory from '../Orders/Pages/OrderHistory/Components/OrderHistory/OrderHistory';
import { BrandListPage } from '../Pages/BrandListPage/BrandListPage';
import { EmbeddedIframe } from '../Pages/EmbeddedIframePage/EmbeddedIframe';
import { PaymentProcessingPage } from '../Pages/PaymentProcessingPage/PaymentProcessingPage';
import { StaticBreadcrumbs } from '../Partials/Breadcrumbs/StaticBreadcrumbs';
import { FooterSections } from '../Partials/Footer/FooterSection/FooterSections';
import Header from '../Partials/Header/Header';
import { ImageGallery } from '../Partials/ImageGallery/ImageGallery';
import { ProductCard } from '../Partials/ProductCard/ProductCard';
import { ProductInformation } from '../Partials/ProductInformation/ProductInformation';
import { ProductList } from '../Partials/ProductList/ProductList';
import { AddToCart } from '../Purchase/Cart/Modifications/AddItem/Components/AddToCart/AddToCart';
import { VippsExpress } from '../Purchase/Checkout/Payments/PaymentMethods/Vipps/Page/VippsExpress';
import { CartDrawerRecommendedProducts } from '../Recommendations/Components/RecommededProducts/CartDrawerRecommendedProducts';
import { RecommendedProducts } from '../Recommendations/Components/RecommededProducts/RecommendedProducts';
import { ButtonsTest } from '../Styleguide/ButtonsTest/ButtonsTest';
import VisitorIntelligenceTracker from '../Tracking/VisitorIntelligence/VisitorIntelligenceTracker';
import { ExpectedDeliveryDateViewWrapper } from './ExpectedDeliveryDate/ExpectedDeliveryDateViewWrapper';
import { ProductInfoLabel } from './InfoLabel/ProductInfoLabel';
import { ProductTopLabel } from './InfoLabel/ProductTopLabel';
import { Props } from './Types';

if (!isServerRendering()) {
    smoothscroll.polyfill();
}

if (isServerRendering()) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useStaticRendering(true);
}

// eslint-disable-next-line
declare let global: any;

export const Components: Record<string, typeof React.Component | React.FC<Props>> = {
    ImageGallery: ImageGallery,
    AddToCart: AddToCart,
    CallToAction: CallToAction,
    CallToActionList: CallToActionList,
    ProductCard: ProductCard,
    ProductList: ProductList,
    Header: Header,
    FooterSections: FooterSections,
    ProductInformation: ProductInformation,
    CookiesConsent: CookiesConsent,
    MainBanner: MainBanner,
    MainBannerGallery: MainBannerGallery,
    OrderDetails: OrderDetails,
    Video: Video,
    OrderHistory: OrderHistory,
    StaticBreadcrumbs: StaticBreadcrumbs,
    BrandListPage: BrandListPage,
    ProductImpression: ProductImpression,
    ImageBanner: ImageBanner,
    SimpleImageBanner: SimpleImageBanner,
    LinkList: LinkList,
    TextBanner: TextBanner,
    WideImageBanner: WideImageBanner,
    ProductPageDiscount: ProductPageDiscount,
    UnsubscribeReason: UnsubscribeReason,
    NewsletterSubscription: NewsletterSubscription,
    CategoryBlock: CategoryBlock,
    SectionBanner: SectionBanner,
    FeaturedInfo: FeaturedInfo,
    CircleInfo: CircleInfo,
    CategoryHeader: CategoryHeader,
    VisitorIntelligenceTracker: VisitorIntelligenceTracker,
    BrandList: BrandList,
    FavouriteProductButton: FavouriteProductButton,
    FavouriteProductsList: FavouriteProductsList,
    CustomerHeader: CustomerHeader,
    AlertRibbon: AlertRibbon,
    FirstFavouriteModal: FirstFavouriteModal,
    ProductTopLabel: ProductTopLabel,
    ProductInfoLabel: ProductInfoLabel,
    PaymentProcessingPage: PaymentProcessingPage,
    ProductPageAvailabilityNotificationWrapper: ProductPageAvailabilityNotificationWrapper,
    RecommendedProducts: RecommendedProducts,
    EmbeddedIframe: EmbeddedIframe,
    ButtonsTest: ButtonsTest,
    ExpectedDeliveryDateViewWrapper: ExpectedDeliveryDateViewWrapper,
    VippsExpress: VippsExpress,
    CartDrawerRecommendationsBlock: CartDrawerRecommendedProducts,
    RxBanner: RxBanner,
    ActionHero: ActionHero
};

// register components as global required by ReactJS.NET
for (const component in Components) {
    global[component] = Components[component];
}

global.React = React;
global.ReactDOM = ReactDOM;
global.ReactDOMServer = ReactDOMServer;
